<template>
    <div data-slot="icon-tile" :class="tileClass">
        <slot></slot>
    </div>
</template>

<script>
// Vue port of roadie IconTile (iconTileVariants): frames a bare Phosphor icon
// slot, sized via the [&_svg] selector. Use weight="bold" or "duotone".
const INTENT = {
    neutral: "intent-neutral",
    brand: "intent-brand",
    "brand-secondary": "intent-brand-secondary",
    accent: "intent-accent",
    danger: "intent-danger",
    success: "intent-success",
    warning: "intent-warning",
    info: "intent-info",
};
const EMPHASIS = {
    strong: "emphasis-strong",
    normal: "emphasis-normal text-subtle",
    subtle: "emphasis-subtle text-subtle",
    subtler: "emphasis-subtler text-subtle",
};
const SIZE = {
    xs: "size-6 p-1 [&_svg]:size-4",
    sm: "size-8 p-1.5 [&_svg]:size-5",
    md: "size-10 p-2 [&_svg]:size-6",
    lg: "size-12 p-2.5 [&_svg]:size-7",
    xl: "size-14 p-3 [&_svg]:size-8",
    "2xl": "size-16 p-3.5 [&_svg]:size-9",
    "3xl": "size-20 p-4 [&_svg]:size-12",
};
// Square radius scales with the tile; circle ignores these (always rounded-full).
const SQUARE_RADIUS = {
    xs: "rounded-md",
    sm: "rounded-lg",
    md: "rounded-xl",
    lg: "rounded-xl",
    xl: "rounded-2xl",
    "2xl": "rounded-2xl",
    "3xl": "rounded-3xl",
};

export default {
    name: "IconTile",
    props: {
        intent: { type: String, default: "", validator: (v) => v === "" || v in INTENT },
        emphasis: { type: String, default: "subtle", validator: (v) => v in EMPHASIS },
        size: { type: String, default: "md", validator: (v) => v in SIZE },
        shape: { type: String, default: "square", validator: (v) => v === "square" || v === "circle" },
    },
    computed: {
        tileClass() {
            const classes = ["inline-flex items-center justify-center [&_svg]:shrink-0"];
            if (INTENT[this.intent]) classes.push(INTENT[this.intent]);
            if (EMPHASIS[this.emphasis]) classes.push(EMPHASIS[this.emphasis]);
            if (SIZE[this.size]) classes.push(SIZE[this.size]);
            if (this.shape === "circle") classes.push("rounded-full");
            else if (SQUARE_RADIUS[this.size]) classes.push(SQUARE_RADIUS[this.size]);
            return classes.join(" ");
        },
    },
};
</script>
